"use client"
import { useUIBuilderLocaleStore } from "@/(admin)/modules/ui-builder/store/useUIBuilderLocaleStore"
import { useDomainStore } from "@/stores/use-domain-store"
import { getEnforcedDomainValue } from "@/utils/admin-domain-filter"
import { ComponentConfig } from "@measured/puck"
import { Select, Typography } from "antd"
import { useEffect, useMemo, useState } from "react"
import { useWebsiteCategories } from "../LatestNews/hooks/useWebsiteCategories"
import { PostGridByCategoryProps, RenderConfig } from "./RenderConfig"

// Field chỉ hiển thị (read-only): domain luôn bám theo site đang chọn ở admin,
// và tự ghi vào block content để public render đọc lại. Không cho sửa tay vì
// không có tình huống đang ở site này lại sửa page của site khác.
function WebsiteDomainAutoField(props: any) {
  const { selectedDomain } = useDomainStore()
  const adminDomain = getEnforcedDomainValue(selectedDomain)

  useEffect(() => {
    if (adminDomain && props.value !== adminDomain) {
      props.onChange(adminDomain)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminDomain, props.value])

  return (
    <div>
      <Typography.Title level={5}>Website</Typography.Title>
      {adminDomain ? (
        <Typography.Text>{adminDomain}</Typography.Text>
      ) : (
        <Typography.Text type="warning">Vui lòng chọn Website ở thanh admin trước</Typography.Text>
      )}
    </div>
  )
}

function PostGridCategorySelect(props: any) {
  const locale = useUIBuilderLocaleStore(state => state.locale)
  const { selectedDomain } = useDomainStore()
  const adminDomain = getEnforcedDomainValue(selectedDomain)
  const { categories, loading } = useWebsiteCategories({
    websiteDomain: adminDomain,
    locale,
  })
  const [searchValue, setSearchValue] = useState("")

  // Prop lưu string[] (idCategory) để tương thích content cũ; Select dùng number.
  const selectedValues = useMemo(() => {
    if (!props.value || !Array.isArray(props.value)) return undefined
    return props.value.map(Number)
  }, [props.value])

  const handleChange = (values: number[] | undefined) => {
    props.onChange?.(values?.length ? values.map(String) : [])
  }

  const options = useMemo(() => {
    const filtered = searchValue
      ? categories.filter(c => c.name.toLowerCase().includes(searchValue.toLowerCase()))
      : categories
    return filtered.map(cat => ({
      value: cat.id,
      label: cat.name,
    }))
  }, [categories, searchValue])

  const isDisabled = !adminDomain

  return (
    <div>
      <Typography.Title level={5}>Categories</Typography.Title>
      <Select
        mode="multiple"
        showSearch
        style={{ minWidth: "14rem" }}
        placeholder={isDisabled ? "Chọn Website trước" : "Select Category"}
        value={selectedValues}
        onChange={handleChange}
        onSearch={setSearchValue}
        searchValue={searchValue}
        options={options}
        className="w-full"
        loading={loading}
        disabled={isDisabled}
        filterOption={false}
        allowClear
        onClear={() => handleChange(undefined)}
      />
    </div>
  )
}

export const PostGridByCategory: ComponentConfig<PostGridByCategoryProps> = {
  label: "Tamda Foods | PostGridByCategory",
  fields: {
    websiteDomain: {
      type: "custom",
      label: "Website",
      render: props => <WebsiteDomainAutoField {...props} />,
    },
    idCategory: {
      type: "custom",
      label: "Categories",
      render: props => <PostGridCategorySelect {...props} />,
    },
  },
  defaultProps: {
    idCategory: [],
    websiteDomain: "",
  },
  ...RenderConfig,
}
